import { z } from 'zod';

export const LeadStatusSchema = z.enum([
  'CREATED',
  'CONTACTED',
  'QUALIFIED',
  'VERIFYING_PAYMENT',
  'SOLD',
]);

export type LeadStatus = z.infer<typeof LeadStatusSchema>;

export const MarketingAdSchema = z.object({
  id: z.string(),
  adsetId: z.string(),
  campaignId: z.string().optional(),
  name: z.string(),
  active: z.boolean().default(true),
  redirectionType: z.enum(['form', 'whatsapp']).default('form'),
  whatsappMessage: z.string().optional(),
  createdAt: z.any().optional(),
  metaAdId: z.string().optional(),
});

export type MarketingAd = z.infer<typeof MarketingAdSchema>;

export const GlobalPixelSchema = z.object({
  id: z.string(),
  name: z.string(),
  pixelId: z.string(),
  capiToken: z.string(),
  active: z.boolean().default(true),
  createdAt: z.any().optional(),
});

export type GlobalPixel = z.infer<typeof GlobalPixelSchema>;

export const MarketingAdSetSchema = z.object({
  id: z.string(),
  campaignId: z.string(),
  name: z.string(),
  pixelId: z.string().optional(),
  capiToken: z.string().optional(),
  globalPixelId: z.string().optional(),
  active: z.boolean().default(true),
  createdAt: z.any().optional(),
  metaAdsetId: z.string().optional(),
});

export type MarketingAdSet = z.infer<typeof MarketingAdSetSchema>;

export const MarketingCampaignSchema = z.object({
  id: z.string(),
  ownerId: z.string().optional(),
  name: z.string(),
  active: z.boolean().default(true),
  slug: z.string().optional(),
  createdAt: z.any().optional(),
  statusMapping: z.record(z.string(), z.string()).optional(),
  metaCampaignId: z.string().optional(),
});

export type MarketingCampaign = z.infer<typeof MarketingCampaignSchema>;
